var map = {
	"./am.json": [
		1028,
		28
	],
	"./ar.json": [
		4191,
		596
	],
	"./ckb.json": [
		3934,
		934
	],
	"./en.json": [
		7485,
		485
	],
	"./fa.json": [
		1616,
		616
	],
	"./ku.json": [
		6261,
		261
	],
	"./om.json": [
		7260,
		260
	],
	"./pa.json": [
		3285,
		285
	],
	"./ps.json": [
		3163,
		163
	],
	"./ru.json": [
		547,
		547
	],
	"./so.json": [
		8253,
		253
	],
	"./sq.json": [
		438,
		438
	],
	"./ti.json": [
		7846,
		846
	],
	"./ur.json": [
		735,
		735
	],
	"./vi.json": [
		9002,
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9989;
module.exports = webpackAsyncContext;